import { axios } from "../../config/axios";

export const feedbackAPI = {
  GETSentAndReceived(options) {
    const optionsNew = this.SetLocationParam(options)

    return axios.get('/api/v3/feedback/surveys_sent_and_received', optionsNew)
                .then((resp) => resp.data.result);
  },
  GETCurrentScores(options) {
    const optionsNew = this.SetLocationParam(options)

    return axios.get('/api/v3/feedback/current_scores', optionsNew)
                .then((resp) => resp.data.result);
  },
  GETScoresSummaryGraphs(options) {
    const optionsNew = this.SetLocationParam(options)

    return axios.get('/api/v3/feedback/scores_summary_graphs', optionsNew)
                .then((resp) => resp.data.result);
  },
  GETScoresSummaryComments(options) {
    const optionsNew = this.SetLocationParam(options)

    return axios.get('/api/v3/feedback/scores_summary_comments', optionsNew)
                .then((resp) => resp.data.result);
  },
  GETImportantFeedback(options) {
    const optionsNew = this.SetLocationParam(options)

    return axios.get('/api/v3/feedback/important_feedback', optionsNew)
                .then((resp) => resp.data.result);
  },
  GETFeedbackReport(options, isCsv) {
    const optionsNew = this.SetLocationParam(options)

    // If the option isCsv is set, then add it to params
    // otherwise delete it from the params
    if(isCsv) {
      Object.assign(optionsNew.params, {
        isCsv: true
      })
    } else if(optionsNew.params.isCsv) {
      delete optionsNew.params.isCsv
    }

    return axios.get('/api/v3/feedback/feedback_report', optionsNew)
                .then((resp) => resp.data.result);
  },
  DELCsvReport(options) {
    return axios.get('/api/v3/feedback/feedback_report_delete_csv', options)
                .then((resp) => resp.data.result);
  },
  GETOrganizationInfo() {
    return axios.get('/api/v3/feedback/organization')
                .then((resp) => resp.data.result.name);
  },
  GETRegionList() {
    return axios.get('/api/v3/feedback/regions')
                .then((resp) => resp.data.result);
  },
  GETStoreList() {
    return axios.get('/api/v3/feedback/stores_with_email')
                .then((resp) => resp.data.result.items);
  },
  GETBaseStoreList() {
    return axios.get('/api/v3/feedback/stores')
                .then((resp) => resp.data.result);
  },
  GETScoresGraph(options) {
    return axios.get('/api/v3/feedback/scores_graph', options)
                .then((resp) => resp.data.result);
  },
  GETStoreRanking(options) {
    return axios.get('/api/v3/feedback/store_ranking', options)
                .then((resp) => resp.data.result);
  },
  PUTFeedbackTags(options) {
    return axios.get('/api/v3/feedback/feedback_tagged', options)
                .then((resp) => resp);
  },
  /**
   * fetches feedback alert settings
   * @return {Object} {emails: [], nps_value: number, csr_value: number, product_value: number}
   */
  GETFeedbackAlert() {
    return axios.get('/api/v3/feedback/feedback_alert')
                .then((resp) => resp.data.result);
  },
  /**
   * fetches feedback alert settings
   * @options {Object} options.params{nps: {}, crs: {}, product: {}, emails: []}
   * @returns {object} status code 200 if successful or error
   */
  POSTFeedbackAlert(options) {
    return axios.post('/api/v3/feedback/update_feedback_alert', options)
                .then((resp) => resp);
  },
  SetLocationParam(options) {
    if(localStorage.budtender_store_id) {
      Object.assign(options.params, {
        store_id: localStorage.budtender_store_id
      })

      if (options.params.region_id) delete options.params.region_id
    } else if(localStorage.budtender_region_id) {
      Object.assign(options.params, {
        region_id: localStorage.budtender_region_id
      })
    }

    // The options object seems to persist across many calls
    // so this deletion stage is necessary to prevent them from
    // being kept in the parameters
    if (!localStorage.budtender_store_id && options.params.store_id) {
      delete options.params.store_id
    }

    if (!localStorage.budtender_region_id && options.params.region_id) {
      delete options.params.region_id
    }

    return options
  }
}
